<template>
  <div class="DetailR">
    <div class="content-info">
      <div class="">
        <router-link class="return" v-bind:to="'/reservation'"> Regresar</router-link>
        <p class="o-b t-i">Detalle de reservación</p>
        <div class="b-c">
          <div class="content-i-r b-r">
            <p class="o-b sub-t">Servicio</p>
            <div class="m-top c-in-g">
              <div class="content-i-r-g">
                <p class="o-b t-y">Fecha</p>
                <p class="" >{{userAppointment.date}}</p>
              </div>
              <div class="content-i-r-g">
                <p class="info-da o-b t-y">Servicio</p>
                <p class="info-da">{{servicio}}</p>
              </div>
              <br>
              <div class="content-i-r-g">
                <p class="o-b t-y">Hora</p>
                <p class="">{{userAppointment.hour}}</p>
              </div>
              <div class="content-i-r-g">
                <p class="info-da o-b t-y">Promoción</p>
                <p class="info-da">{{promocode}}</p>
              </div>
            </div>
          </div>


          <div v-if="typeof userAppointment.cancelDate !== 'undefined' " class="content-i-r" style="float: left;">
            <p class="o-b t-i">Reservación cancelada</p>
          </div>
          <div v-if="userAppointment.status == 2 " class="content-i-r" style="float: left;">
            <p class="o-b t-i">Reservación Finalizada</p>
          </div>


          <div v-if="typeof userAppointment.cancelDate === 'undefined' "  class="content-i-r b-r">
            <div v-if="userAppointment.status != 2">
              <p class="o-b sub-t">Estilista</p>
              <select v-model="userIdAssign" class="select-css">
                <option value="">Selecciona una opción</option>
                <option v-for="(data, index) in userStylelist" :key="index" :value="data.id">
                  {{data.fullname}}
                </option>
              </select>
              <button v-on:click="asignar" class="o-b but-g " id="basic-addon1">Asignar</button>
            </div>
          </div>

          <div v-if="typeof userAppointment.cancelDate === 'undefined' " class="content-i-r b-r" >
            <div v-if="userAppointment.status != 2">
              <p class="o-b sub-t">Reservación</p><br><br>
              <button v-if="userAppointment.cancelDate == null"  v-on:click="final(id)" class="o-b but-rfi" id="basic-addon1">Finalizar reservación</button>
              <button v-if="userAppointment.cancelDate == null"  v-on:click="cancel(id)" class="o-b but-r" id="basic-addon1">Cancelar reservación</button>
            </div>
          </div>

          <div v-if="typeof userAppointment.cancelDate === 'undefined' " class="content-i-r" >
            <div v-if="userAppointment.status != 2">
              <p class="o-b sub-t">Horario</p>
              <select v-model="userHourAssign" class="select-css select-css-h">
                <option value="" >Selecciona una opción</option>
                <option v-for="(data, index) in hours" :key="index" :value="data.timestamp">
                  {{data.formatted.split('-')[1]}}
                </option>
              </select>
              <button v-on:click="asignarHour" class="o-b but-g " id="basic-addon1">Asignar</button>
            </div>
          </div>
        </div>
        
        <div class="b-c">
          <p class="o-b sub-t">Cliente</p>
          <button v-on:click="activeUR = !activeUR" class="f-r btn-t"><i class="fa fa-angle-down" aria-hidden="true"></i></button>
          <div v-bind:class="{'c-t-info-h-active': activeUR}" class="c-t-info">
            <div class="row">
              <div class="col-md-6 info-u-c">
                <p class="o-b sub-t">Datos</p><br><br>
                <img class="img_user" :src=appointmentUser.avatar>
                <div class="info-u">  
                  <p>{{appointmentUser.fullname}}</p>
                  <p>{{appointmentUser.username}}</p>
                  <p>{{appointmentUser.phone}}</p>
                  <p>Usuario desde {{appointmentUser.createdAt}}</p>
                </div>
              </div>
              <div class="col-md-6 info-u-c">
                <p class="o-b sub-t">Comentarios de reservacion</p><br><br>
                <p>{{userAppointment.comment}}</p>
                <p class="o-b sub-t">Comentarios de servicio</p><br><br>
                <p>{{userAppointment.commentServicio}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="b-c">
          <p class="o-b sub-t">Dirección</p>
          <button v-on:click="activeMR = !activeMR" class="f-r btn-t"><i class="fa fa-angle-down" aria-hidden="true"></i></button>
          <div v-bind:class="{'c-t-info-h-active': activeMR}" class="c-t-info m-top">
            <div class="row">
              <div class="col-md-4 info-u-c">
                <p class="o-b t-y">Hora</p>
                <p>{{userAppointment.hour}}</p>
                <p class="o-b t-y">Direccion</p>
                <p>{{direccion}}</p>
                <p class="o-b t-y">Referencias</p>
                <p>{{appoinmentAddress.references}}</p>
                <p class="o-b t-y">Estacionamiento</p>
                <p>{{appoinmentAddress.interior}}</p>
  
              </div>
              <div class="col-md-8 info-u-c">
                <iframe width="100%" height="200" frameborder="0" style="border:0" v-bind:src="'https://www.google.com/maps/embed/v1/place?q=' + latitude +','+ longitude  +'&amp;key=AIzaSyCmpzzR36Qw8KG43ulofBWCMtQWL8kKN8A'"></iframe>
              </div>
            </div>
          </div>
        </div>

        <div class="b-c m-bottom">
          <p class="o-b sub-t">Informacion de pago</p>
          <button v-on:click="activeDR = !activeDR" class="f-r btn-t"><i class="fa fa-angle-down" aria-hidden="true"></i></button>
          <div v-bind:class="{'c-t-info-h-active': activeDR == true}" class="c-t-info m-top">
            <div class="row">
              <div class="col-md-4 info-u-c">
                <p class="o-b t-y">Estatus</p>
                <p>Pagado</p>
              </div>
              <div class="col-md-8 info-u-c">
                <p class="o-b t-y">Cargos</p>
                <p>${{userAppointment.finalAmount}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>

import User from '../parse/models/User'
import Appointment from '../parse/models/Appointment'
import BlockedSchedule from '../parse/models/BlockedSchedule'

export default {
  name: 'DetailR',
  components: {
  },
  data () {
    return {
      id: this.$route.params.id, 
      activeUR: true,
      activeMR: false,
      activeDR: false,
      userAppointment: {},
      userStylelist: [],
      userIdAssign: "",
      userHourAssign: "",
      formAssign: {
        userId: "",
        appointmentId: "",
      },
      appointmentUser: [],
      appoinmentAddress: [],
      appoinmentCard: [],
      servicio: "",
      latitude: "",
      longitude: "",
      direccion: "",
      promocode: "",
      promocodeDisco: "",
      hours:[]
    }
  },
  beforeMount(){



    User.loadStylelist().then((user) => {
      this.userStylelist = user
      
    }) 

    Appointment.detail(this.id)
    .then(appo => {

      this.userAppointment = appo

      console.log(appo)

      this.servicio = appo.service.name
      this.direccion = appo.data.address.redacted
      this.latitude = appo.data.address.location.latitude
      this.longitude = appo.data.address.location.longitude
     
      if (appo.data.promocode){
        this.promocode = appo.data.promocode.code,
        this.promocodeDisco =  appo.data.promocode.discount
      }

      this.initHours(appo.hourBlocked)

      appo.loadUser(this.userAppointment)
      .then(user => this.appointmentUser = user)
      .catch(error => console.log(error))

      /*appo.loadAddress(this.userAppointment)
        .then(addresses => this.appoinmentAddress = addresses)
        .catch(error => console.log(error))*/

      /*appo.loadCards(this.userAppointment)
        .then(cards => this.appoinmentCard = cards)
        .catch(error => console.log(error))*/
    })
    .catch(error => console.log(error))
  },

  methods: {

    initHours(date){
      BlockedSchedule.getHours(date).then((hours) => {
        this.hours = hours
        console.log(hours)
      })
    },
    final(id){
      this.$swal({
        title: '',
        text: '¿Estás seguro de que quieres finalizar esta reservación?',
        type: 'warning',
        confirmButtonText: 'Finalizar',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if(result.value) {
          this.$swal('', 'Reservación finalizada', 'success')
          Appointment.finalService(id)
          .then(resultado => this.reload())
          .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })   
    },
    cancel(id){
      this.$swal({
        title: '',
        text: '¿Estás seguro de que quieres cancelar esta reservacíon?',
        type: 'warning',
        confirmButtonText: 'Cancelar',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if(result.value) {
          this.$swal('', 'Reservación cancelada', 'success')
          Appointment.cancelData(id)
          .then(resultado => this.reload())
          .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })        
    },
    cambiar(){
      this.$swal({
        title: '',
        text: '¿Estás seguro de que quieres convertir al usuario?',
        type: 'warning',
        confirmButtonText: 'Cambiar',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if(result.value) {
          this.$swal('', 'Cambio correcto', 'success')
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })
    },

    asignar(){
      this.formAssign = { userId : this.userIdAssign, appointmentId : this.id }
      this.$swal({
        title: '',
        text: '¿Estás seguro de que quieres asignar a este estilista?',
        type: 'warning',
        confirmButtonText: 'Asignar',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if(result.value) {
          this.$swal('', 'Asignacion correcta', 'success')
          Appointment.assign(this.formAssign)
            .then(resultado => this.reload())
            .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })
    },
    asignarHour(){
      
      this.formAssign = { appointmentId : this.id, hourId : this.userHourAssign }
      
      this.$swal({
        title: '',
        text: '¿Estás seguro de que cambiar el horario de la reservación?',
        type: 'warning',
        confirmButtonText: 'Cambiar',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if(result.value) {
          this.$swal('', 'Cambio correcto', 'success')
          Appointment.assignHour(this.formAssign)
            .then(resultado => this.reload())
            .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })
    },
    reload(){
      this.$forceUpdate()
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .return{
    color: #000;
    text-decoration: none;
  }

  .m-bottom {
    margin-bottom: 1em;
  }

  .select-css {
    display: block;
    font-size: 16px;
    font-weight: 400;
    color: #444;
    line-height: 1.3;
    padding: .4em 1.4em .3em .8em;
    width: 400px;
    max-width: 100%; 
    box-sizing: border-box;
    margin: 20px 0;
    border: none;
    box-shadow: 0 1px 0 1px rgba(0,0,0,.03);
    border-radius: .3em;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: #F3F3F3;
    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),
      linear-gradient(to bottom, #F3F3F3 0%,#F3F3F3 100%);
    background-repeat: no-repeat, repeat;
    background-position: right .7em top 50%, 0 0;
    background-size: .65em auto, 100%;
}
.select-css::-ms-expand {
    display: none;
}
.select-css:hover {
    border-color: #888;
}
.select-css:focus {
    border-color: #aaa;
    box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);
    box-shadow: 0 0 0 3px -moz-mac-focusring;
    color: #222; 
    outline: none;
}
.select-css option {
    font-weight:normal;
}

.select-css-h {
  width: 100%;
}

  .t-y{
    margin-bottom: 0;
  }

  .c-in-g{
    overflow: hidden;
  }

  .content-i-r-g{
    width: 50%;
    display: inline-block;
    float: left;
  }

  .info-da{
    padding-left: 10px;
  }
  
  .content-i-r{
    width: 25%;
    display: inline-block;
    padding: 10px;
    float: left;
  }
  
  .b-r{
    border-right: 2px solid #eeeeee;
  }

  .c-t-info{
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
  }

  .c-t-info-h-active{
    height: auto;
    max-height: 600px;
  }

  /* USER INFO */
  .img_user{
    width: 138px;
    height: 138px;
    border-radius: 70px;
    float: left;
    margin-right: 20px;
  }

  .info-u{
    display: inline;
  }

  .info-ac button{
    display: inline;
  }

  table tbody tr{
    background: #F3F3F3;
  }

  .but-r:hover{ 
    background: rgb(231, 76, 84);
  }

  .but-c{
    background: #85EEB3;
    color: #fff;
    border: 0;
    width: 270px;
    height: 40px;
    border-radius: 10px;
    font-size: 18px;
  }

  .but-c:hover{ 
    background: #14fc78;
  }
  
  

  .m-r{
    margin-right: 50px;
  }

  .dropdown-menu{
    width: 120px;
  }

  /* Container */
  
  .content-info{
    margin-left: 310px;
    margin-right: 50px;
  }

  .c-i-c{
    width: 235px;
    height: 51px;
    background: #000;
    text-align: center;
    border-radius: 20px;
  }

  .t-u-c{
    padding-top: 14px;
    color: #fff;
    font-size: 16px;
  }

  .b-c {
    margin-right: 50px;
    margin-top: 37px;
    border: 1px solid #f6f6f6;
    -webkit-box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    -moz-box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    padding: 15px;
    overflow: hidden;
  }

  .sub-t{
    font-size: 19px;
    display: inline;
  }

  .i-f-s{
    width: 25px;
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .c-f-g{
    background: #f3f3f3;
    border: none;
    padding: 2px;
    height: 40px;
  }

  .but-g{
    background: #85EEB3;
    color: #fff;
    border: 0;
    width: 140px;
    height: 40px;
    border-radius: 10px;
  }
  .but-g:hover{ 
    background: #14fc78;
  }

  .but-r{
    background: #E96369;
    color: #fff;
    border: 0;
    width: 200px;
    height: 40px;
    border-radius: 10px;
    margin-top: 10px;
  }
  
  .but-rfi{
    background: #007bff;
    color: #fff;
    border: 0;
    width: 200px;
    height: 40px;
    border-radius: 10px;
  }


  .but-r:hover{ 
    background: rgb(231, 76, 84);
  }

  .btn-f{
    margin: 0 40px 0 20px;
  }

  .f-r{
    float: right;
  }

  .btn-t{
    background: #fff;
    border: none;
  }

  .s-o{
    background: #f3f3f3;
    border: none;
    font-family: "Open regular";
    font-size: 16px;
    padding: 5px;
  }

  .s-o option{
    padding: 5px;
  }

  .table{
    border: 1px solid #f6f6f6;
    text-align: center;
  }
  .btn-actions{
    background: #f6f6f6;
    border: none;
  }

</style>
